// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"8982115b","149":"bd4042c7","201":"eabc7490","710":"82bcead5"}[chunkId] + ".chunk.css";
};